import React from 'react';
import { getStyle, TIMING } from './template.utils';
import { JRCAppTabs } from './JRCAppTab';
import { JRCIcon } from '../JRCIcon/JRCIcon';
import { group } from '../Form/Input/JRCSelect/JRCInputSelect.utils';
import { useIntl } from 'react-intl';
import type { JRCAppColumnProps } from './template.type';
import {
    AppColumn,
    AppTabContainer,
    AppTabLabel,
    AppTitle,
    DisappearDescription,
    EasterEggIcon,
    FlexDescription,
    OpenCloseButton,
    AppTabNav,
} from './template.styles';
import { useLocalStorageState } from '../../hooks/UseLocalStorage';

export function JRCAppColumn({ description, activeTab, tabs = [], mode = 'center', ...props }: JRCAppColumnProps) {
    const intl = useIntl();

    const [open, setOpen] = useLocalStorageState(`column_is_open_${description.label}`, true);
    const [closing, setClosing] = React.useState(false);
    const [tripleClick, setTripleClick] = React.useState(false);
    const [timeoutId, setTimeoutId] = React.useState<number | undefined>(undefined);

    function easterEgg(e: React.MouseEvent) {
        if (e.detail === 3) {
            setTripleClick(true);
            setTimeout(() => setTripleClick(false), 4000);
        }
    }

    function onOpen() {
        setTimeout(() => setOpen(!open), 0);

        setClosing(true);
        if (timeoutId) clearTimeout(timeoutId);
        const tId = window.setTimeout(() => {
            setClosing(false);
        }, TIMING);
        setTimeoutId(tId as any);
    }

    return (
        <AppColumn mode={mode} position="left" {...props} open={open}>
            <div>
                <FlexDescription onClick={easterEgg}>
                    <EasterEggIcon
                        easterEgg={tripleClick}
                        name={`icon-${description.icon}`}
                        variant="circle"
                        color={description.color}
                        size={getStyle(open).iconSize}
                        isMargin={false}
                    />
                    {(open || closing) && <AppTitle>{intl.formatMessage({ id: description.label })}</AppTitle>}
                </FlexDescription>
                {(open || closing) && (
                    <DisappearDescription open={open}>
                        {intl.formatMessage({ id: description.description })}
                    </DisappearDescription>
                )}
            </div>
            <OpenCloseButton open={open} closing={closing} onClick={onOpen} className="open-close">
                <JRCIcon name="icon-chevron-left" color="white" size={12} />
            </OpenCloseButton>
            {!!tabs?.length && (
                <AppTabNav
                    extraMargin={!tabs?.[0]?.group}
                    open={open}
                    role="navigation"
                    aria-label={intl.formatMessage({ id: 'GLOBAL_A11Y_APP_NAV' }, { appName: description.label })}>
                    {tabs?.[0]?.group ? (
                        group(tabs, (v) => v.group || '', false).map((group, groupIndex) => (
                            <React.Fragment key={groupIndex}>
                                <AppTabLabel open={open}>{group.label}</AppTabLabel>
                                <AppTabContainer open={open}>
                                    <JRCAppTabs
                                        tabs={group.options}
                                        activeTab={activeTab}
                                        open={open}
                                        closing={closing}
                                    />
                                </AppTabContainer>
                            </React.Fragment>
                        ))
                    ) : (
                        <AppTabContainer open={open}>
                            <JRCAppTabs tabs={tabs} activeTab={activeTab} open={open} closing={closing} />
                        </AppTabContainer>
                    )}
                </AppTabNav>
            )}
        </AppColumn>
    );
}
